module.exports = __webpack_public_path__ + "img/6_89.4578236a.png";